// extracted by mini-css-extract-plugin
module.exports = {"triggerBtn":"TriggerBtn_triggerBtn__1T0ke","rotateIcon":"TriggerBtn_rotateIcon__CRHWp","circle":"TriggerBtn_circle__2Zq7u","lgIcon":"TriggerBtn_lgIcon__eXNym"};